import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  listPractitionerNames: {},
  getNotificationsDetails: {},
  timezone: null,
  timezoneLoading: false,
  getV3NotificationsDetails: {},
  reportsList: [],
  reportsListLoading: false,
  downloadableReportUrl: null,
  srNotificationFromUploadDate: false,
  srNotificationFromUploadDateLoading: false,
};

const appointmentSettingsSlice = createSlice({
  name: 'appointmentSettingsSlice',
  initialState,
  reducers: {
    getSettingsNotificationsSlice: (state, { payload }) => {
      state.getNotificationsDetails = payload;
    },
    listPractitionerNamesSlice: (state, { payload }) => {
      state.listPractitionerNames = payload;
    },
    getTimezoneSlice: (state, { payload }) => {
      state.timezone = payload;
    },
    getTimezoneLoadingSlice: (state, { payload }) => {
      state.timezoneLoading = payload;
    },
    getV3NotificationsDetailsSlice: (state, { payload }) => {
      state.getV3NotificationsDetails = payload;
    },
    reportsListSlice: (state, { payload }) => {
      state.reportsList = payload;
    },
    reportsListLoadingSlice: (state, { payload }) => {
      state.reportsListLoading = payload;
    },
    downloadableReportUrlSlice: (state, { payload }) => {
      state.downloadableReportUrl = payload;
    },
    setSrNotificationFromUploadDateSlice: (state, { payload }) => {
      state.srNotificationFromUploadDate = payload;
    },
    setSrNotificationFromUploadDateLoadingSlice: (state, { payload }) => {
      state.srNotificationFromUploadDateLoading = payload;
    },
  },
});

const { actions, reducer } = appointmentSettingsSlice;

export const {
  getSettingsNotificationsSlice,
  listPractitionerNamesSlice,
  getTimezoneSlice,
  getTimezoneLoadingSlice,
  getV3NotificationsDetailsSlice,
  reportsListSlice,
  reportsListLoadingSlice,
  downloadableReportUrlSlice,
  setSrNotificationFromUploadDateSlice,
  setSrNotificationFromUploadDateLoadingSlice,
} = actions;

export default reducer;
